export * from './adjunto';
export * from './mensaje';

export * from './chacras/chacra-table/chacra-table.component';
export * from './chacras/chacras-detail/chacra-detail.component';

export * from './persona/persona-detail/persona-detail.component';
export * from './ingeniero-agronomo/ingeniero-agronomo-detail/ingeniero-agronomo-detail.component';
export * from './contacto/contacto-core-detail/contacto-detail.component';

export * from './empresa/empresa-table/empresa-table.component';
export * from './empresa/empresa-detail/empresa-detail.component';

export * from './regional/regional-detail/regional-detail.component';

export * from './padron/padron-list/padron-list.component';

export * from './suelo/suelo-detail/suelo-detail.component';



